/** Sentry fingerprint shared by every dynamic-import / chunk fetch failure. */
export const DYNAMIC_IMPORT_FETCH_FAILURE_FINGERPRINT = [
  'dynamic-import-fetch-failure',
] as const;

/** Initial attempt plus retries. The import is tried this many times total. */
export const CHUNK_LOAD_MAX_ATTEMPTS = 3;

/** Base delay before a retry. Attempt 1 waits 1x, attempt 2 waits 2x. */
export const CHUNK_LOAD_RETRY_BASE_DELAY_MS = 300;

/** Seconds the recovery screen counts down before reloading. */
export const CHUNK_LOAD_RECOVERY_COUNTDOWN_SECONDS = 3;

/**
 * After one automatic reload, further chunk failures in this window stay on
 * the error screen so a still-missing asset cannot refresh forever.
 */
export const CHUNK_LOAD_RECOVERY_COOLDOWN_MS = 30_000;

export const CHUNK_LOAD_RECOVERY_STORAGE_KEY = 'surface.chunk-load-recovery-at';

/** Used when sessionStorage throws. Survives a reload in the same browser session. */
export const CHUNK_LOAD_RECOVERY_COOKIE_KEY = 'surface.chunk-load-recovery-at';

/** Last resort when both sessionStorage and cookies are blocked. */
export const CHUNK_LOAD_RECOVERY_URL_PARAM = 'surface_chunk_recovery_at';
